var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-rating',{attrs:{"color":"#f16816","size":_vm.size,"dense":"","readonly":"","half-increments":"","background-color":"#f16816","value":_vm.rate/2}})}
var staticRenderFns = []

export { render, staticRenderFns }